module.exports = __webpack_public_path__ + "static/img/33_pro.7cbd532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/33_pro.jpg
// module id = gAUx
// module chunks = 0